/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Common_Not_Signed_InInputs */

const en_auth_common_not_signed_in = /** @type {(inputs: Auth_Common_Not_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not signed in`)
};

const es_auth_common_not_signed_in = /** @type {(inputs: Auth_Common_Not_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No has iniciado sesion`)
};

/**
* | output |
* | --- |
* | "Not signed in" |
*
* @param {Auth_Common_Not_Signed_InInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_common_not_signed_in = /** @type {((inputs?: Auth_Common_Not_Signed_InInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Common_Not_Signed_InInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_common_not_signed_in(inputs)
	return es_auth_common_not_signed_in(inputs)
});